export const HOUSE_TRANSFER_PRICE_URL = 'p/tools/v1/notary/home/';
